import React from 'react';

import { Box, BoxProps, get as themeGet, useTheme } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

const StyledSummaryCard = styled(Box)`
  box-shadow: 0px 1px 0px ${themeGet('colors.bmtGrey20')};
`;

const SummaryCard: React.FC<React.PropsWithChildren<BoxProps>> = props => {
  const { theme } = useTheme();

  return <StyledSummaryCard backgroundColor="bmtWhite" borderRadius={theme.space[1]} px={8} {...props} />;
};

export default SummaryCard;
